import { Button, message, Upload as UploadAntd, Image } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { uploadFile } from "react-s3";
// import { s3Config } from "../config/s3Config";
import { ShowToast, Severty } from "../helper/toast";
import { getFileExtension } from "../helper/functions";
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import apiPath from "../constants/apiPath";
const s3Config = {
  region: process.env.REACT_APP_region,
  credentials: {
    accessKeyId: process.env.REACT_APP_aws_access_key,
    secretAccessKey: process.env.REACT_APP_aws_secret_key,
  },
  // endpoint: "https://dunnnit.s3.me-central-1.amazonaws.com/",
  // forcePathStyle: true,
};
// console.log("Region:", process.env.REACT_APP_region);
// console.log("Access Key ID:", process.env.REACT_APP_aws_access_key);
// console.log("Secret Key:", process.env.REACT_APP_aws_secret_key);


const s3Client = new S3Client(s3Config);
const SingleImageUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 50,
  isDimension = false,
  setLoading,
  ...props
}) => {
  const [file, setFile] = useState([]);


  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === 600 && img.height === 600) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions 600X600. uploaded image is ${img.width} X ${img.height}`,
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (fileType.includes(file.type)) {
      } else {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < size;

      if (!isLt2M) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return false;
      }
      isDimension && (await checkImageDimensions(file));
      return true;
    } catch (err) {
      console.log("err",err)
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange([]);
    }
  };

  useEffect(() => {
    if (!value) setFile([]);
  }, [value]);

  // const uploadFileToS3 = async (file, bucketName) => {
  //   const key = "dunnnit/" + imageType + "/" + file.name
  //   const params = {
  //     Bucket: bucketName,
  //     Key: key,
  //     Body: file,
  //   };

  //   const upload = new Upload({
  //     client: s3Client,
  //     params: params,
  //   });

  //   try {
  //     const data = await upload.done();
  //     console.log(data)
  //     if(setLoading){
  //       setLoading(false);
  //     }
  //     return data;
  //   } catch (err) {
  //     throw err;
  //   }
  // };
const uploadViaBackend = async (file, imageType) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("type", imageType); // "Content", "Profile", etc.

  try {
    const response = await fetch(`${apiPath.baseURL}/app/common/image-upload`, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
     console.log("result",result);
     
    if (!response.ok || !result.status) {
      throw new Error(result.message || "Upload failed");
    }

    return result.data?.upload; // Assuming backend responds with { data: { url: "https://..." } }
  } catch (err) {
    ShowToast(err.message || "Upload error", Severty.ERROR);
    throw err;
  }
};


  // const handleImgChange = async (event) => {
  //   const { file } = event;
  //   setFile([file]);
  //   if(setLoading){
  //     setLoading(true);
  //   }
  //   try {
  //     const data = await uploadFileToS3(file, 'dunnnit');
  //     const fileData = {
  //       uid: file.uid,
  //       name: file.name,
  //       status: 'done',
  //       url: "https://dunnnit.s3.me-central-1.amazonaws.com/dunnnit/" + data.Key,
  //       thumbUrl: "https://dunnnit.s3.me-central-1.amazonaws.com/dunnnit/" + data.Key,
  //     };
  //     setFile([fileData]);
  //     if (onChange) {
  //       onChange([fileData]);
  //     }
  //     //   setFile([fileData]);
  //     console.log(data);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleImgChange = async (event) => {
  const { file } = event;
  setFile([file]);

  if (setLoading) {
    setLoading(true);
  }

  try {
    const url = await uploadViaBackend(file, imageType);

    const fileData = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url: url,
      thumbUrl: url,
    };

    setFile([fileData]);
    if (onChange) {
        onChange([fileData]);
    }
  } catch (err) {
    console.error("Upload failed:", err);
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }
};

  return (
    <UploadAntd
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button icon={<UploadOutlined />}>
          {" "}
          {btnName ? `Upload ${btnName}` : ""}
        </Button>
      )}
    </UploadAntd>
  );
};

export default SingleImageUpload;
